import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';

import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';
import uploadOverlay from 'actions/Broadcast/overlays/uploadOverlay';
import ModalHeader from 'components/Modal/Header';
import { OVERLAY_FORM } from 'constants/ModalTypes';
import { LayerForm } from '@shoflo/polymer/components/LayerForm/LayerForm';
const OverlayForm = () => {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === OVERLAY_FORM
  );

  const dispatch = useDispatch();

  const clearThisModal = () => dispatch(clearModal(OVERLAY_FORM));

  const handleSubmit = source => {
    dispatch(uploadOverlay(source));
    dispatch(clearModal(OVERLAY_FORM));
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={clearThisModal}
      data-testid="add-overlay-modal"
    >
      <ModalHeader>Add overlay</ModalHeader>
      <ModalBody>
        <LayerForm
          type="overlay"
          onSubmit={handleSubmit}
          onCancel={clearThisModal}
          supportedFileTypes={
            'jpeg, png, gif (5mb per file size limit)\nImages can be no larger than 1920x1080 px.'
          }
        />
      </ModalBody>
    </Modal>
  );
};

export default OverlayForm;
